export const formatInvoice = invoices => {
  const { customerInvoiceId = "", customerInvoiceType = "" } = invoices;
  return `${customerInvoiceId} ${customerInvoiceType}`;
};



// WEBPACK FOOTER //
// ./src/helpers/invoiceHelpers.js